var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("List")]),_c('hr'),(_vm.tasks.length)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.tasks,"show-expand":"","items-per-page":5},scopedSlots:_vm._u([{key:"expanded-item",fn:function(ref){
var item = ref.item;
return [_c('td',[_vm._v(_vm._s(item.description))])]}},{key:"item.open",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"color":"primary","small":"","to":'/task/' + item.id}},[_vm._v("Open")])]}}],null,false,3784096487)}):_c('p',[_vm._v("No tasks")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }